<section class="section-container">
  <div class="section-content">
    <div class="welcome">
      <h1>Renegociação de cartão</h1>
    </div>

    <app-alert *ngIf="temPropostaDisponivel" [dense]="true" [type]="'info'">
      Você possui uma proposta disponível para pagar a dívida do cartão.
    </app-alert>

    <div *ngIf="debts.length > 0" class="lista-cartoes">
      <div *ngFor="let debt of debts" class="cartao">
        <h2>{{debt.nomeProduto}}</h2>
        <p>{{mascararNumeroCartao(debt)}}</p>
        <p>{{customerData.nome}}</p>
        <button type="button" (click)="redirectFlowDebts(debt)" mat-flat-button color="primary">
          Visualizar proposta
        </button>
      </div>
    </div>
    <div *ngIf="acordos.length > 0" class="lista-cartoes">
      <div *ngFor="let acordo of acordos" class="cartao">
        <h2>{{acordo.nomeProduto}}</h2>
        <p>{{mascararNumeroCartao(acordo)}}</p>
        <p>{{customerData.nome}}</p>
        <button type="button" (click)="redirectFlowAgreements(acordo)" mat-flat-button color="primary">
          Acompanhar acordo
        </button>
      </div>
    </div>
  </div>
</section>